import { useEffect, ReactNode } from "react";
import { useSelector } from "store";
// material-ui
import { CacheProvider } from "@emotion/react";
import createCache, { StylisPlugin } from "@emotion/cache";

// third-party
import rtlPlugin from "stylis-plugin-rtl";

// types
import { ThemeDirection } from "shared/types/config";


interface RTLLayoutProps {
  children: ReactNode;
}

const RTLLayout = ({ children }: RTLLayoutProps) => {
  const { themeDirection } = useSelector((state) => state.config);

  useEffect(() => {
    document.dir = themeDirection;
  }, [themeDirection]);

  const cacheRtl = createCache({
    key: themeDirection === ThemeDirection.RTL ? "rtl" : "css",
    prepend: true,
    stylisPlugins:
      themeDirection === ThemeDirection.RTL ? [rtlPlugin as StylisPlugin] : [],
  });

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
};

export default RTLLayout;
